// src/pages/PesquisaJurisprudencia/components/JurisprudenciaModal.js
import React from 'react';

const JurisprudenciaModal = ({
  item,
  isOpen,
  onClose,
  abaAtiva,
  casoSelecionado,
  loadingAssociar,
  onAssociar,
  onNavegateChat,
  formatarData,
  abrirUrlOriginal
}) => {
  if (!isOpen || !item) return null;

  const handleCopiarTudo = () => {
    const campos = [
      `ID: ${item.id}`,
      `Tribunal: ${item.tribunal_origem}`,
      `URL Original: ${item.url_original}`,
      `Processo: ${item.processo_numero || 'N/A'}`,
      `Relator: ${item.relator || 'N/A'}`,
      `Data do Acórdão: ${item.data_acordao || 'N/A'}`,
      `Meio Processual: ${item.meio_processual || 'N/A'}`,
      `Sumário: ${item.sumario || 'N/A'}`,
      `Decisão: ${item.decisao || 'N/A'}`,
      `Votação: ${item.votacao || 'N/A'}`,
      `Tags: ${item.tags ? item.tags.join(', ') : 'N/A'}`,
      `Palavras-chave: ${item.palavras_chave ? item.palavras_chave.join(', ') : 'N/A'}`,
      `Tema: ${item.tema_classificado || 'N/A'}`,
      `Texto Integral: ${item.texto_integral || 'N/A'}`
    ];
    navigator.clipboard.writeText(campos.join('\n\n'));
    alert('Conteúdo copiado para a área de transferência!');
  };

  const handleCopiarTextoIntegral = () => {
    if (!item.texto_integral) { alert('Texto integral não disponível'); return; }
    navigator.clipboard.writeText(item.texto_integral);
    alert('Texto integral copiado para a área de transferência!');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>

        <div className="modal-header">
          <h2 className="modal-title">
            Detalhes da Jurisprudência — {item.processo_numero} ({item.tribunal_origem})
            {abaAtiva === 'caso' && casoSelecionado && (
              <span className="modal-subtitle">
                Relacionada ao caso: {casoSelecionado.name || `Caso ${casoSelecionado.id}`}
              </span>
            )}
          </h2>
        </div>

        <div className="modal-body">
          <div className="detalhes-grid">
            <div className="detalhe-item">
              <div className="detalhe-label">ID:</div>
              <div className="detalhe-valor">{item.id}</div>
            </div>
            <div className="detalhe-item">
              <div className="detalhe-label">Tribunal:</div>
              <div className="detalhe-valor">
                <span className={`tribunal-badge ${item.tribunal_origem.toLowerCase()}`}>
                  {item.tribunal_origem}
                </span>
              </div>
            </div>
            <div className="detalhe-item">
              <div className="detalhe-label">Processo:</div>
              <div className="detalhe-valor">
                {item.processo_numero ? (
                  <button
                    className="processo-link"
                    onClick={() => abrirUrlOriginal(item.url_original)}
                    title="Clique para abrir o acórdão original"
                  >
                    {item.processo_numero}
                  </button>
                ) : 'N/A'}
              </div>
            </div>
            <div className="detalhe-item">
              <div className="detalhe-label">Relator:</div>
              <div className="detalhe-valor">{item.relator || 'N/A'}</div>
            </div>
            <div className="detalhe-item">
              <div className="detalhe-label">Data do Acórdão:</div>
              <div className="detalhe-valor">{formatarData(item.data_acordao)}</div>
            </div>
            <div className="detalhe-item">
              <div className="detalhe-label">Meio Processual:</div>
              <div className="detalhe-valor">{item.meio_processual || 'N/A'}</div>
            </div>
            <div className="detalhe-item">
              <div className="detalhe-label">Votação:</div>
              <div className="detalhe-valor">{item.votacao || 'N/A'}</div>
            </div>
            <div className="detalhe-item">
              <div className="detalhe-label">Tema Classificado:</div>
              <div className="detalhe-valor">{item.tema_classificado || 'N/A'}</div>
            </div>
            <div className="detalhe-item">
              <div className="detalhe-label">Tags:</div>
              <div className="detalhe-valor">
                {item.tags && item.tags.length > 0 ? (
                  <div className="detalhe-tags">
                    {item.tags.map((tag, index) => (
                      <span key={index} className="tag-badge">{tag}</span>
                    ))}
                  </div>
                ) : 'N/A'}
              </div>
            </div>
            <div className="detalhe-item">
              <div className="detalhe-label">Palavras-chave:</div>
              <div className="detalhe-valor">
                {item.palavras_chave ? item.palavras_chave.join(', ') : 'N/A'}
              </div>
            </div>
            <div className="detalhe-item">
              <div className="detalhe-label">Sumário:</div>
              <div className="detalhe-valor">{item.sumario || 'N/A'}</div>
            </div>
            <div className="detalhe-item">
              <div className="detalhe-label">Decisão:</div>
              <div className="detalhe-valor">{item.decisao || 'N/A'}</div>
            </div>
            <div className="detalhe-item">
              <div className="detalhe-label">Texto Integral:</div>
              <div className="detalhe-valor">{item.texto_integral || 'N/A'}</div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <div className="footer-left">
            <button className="botao-copiar" onClick={handleCopiarTudo}>
              📋 Copiar Tudo
            </button>
            <button className="botao-copiar" onClick={handleCopiarTextoIntegral}>
              📄 Copiar Texto Integral
            </button>
          </div>

          <div className="footer-center">
            <button className="botao-chat" onClick={onNavegateChat}>
              💬 Chat com IA
              {abaAtiva === 'caso' && casoSelecionado && <small> + Caso</small>}
            </button>
            {/* Botão Associar: apenas disponível na aba Pesquisa por Caso */}
            {abaAtiva === 'caso' && casoSelecionado && (
              <button
                className="botao-associar"
                onClick={() => onAssociar(item)}
                disabled={loadingAssociar}
              >
                {loadingAssociar ? <>⏳ Associando...</> : <>🔗 Associar Acórdão ao Caso</>}
              </button>
            )}
          </div>

          <div className="footer-right">
            <button className="botao-fechar" onClick={onClose}>Fechar</button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default JurisprudenciaModal;